module.exports = __webpack_public_path__ + "static/media/logo.2905c021.png";